import React, { Component } from 'react';
import CommonYesNo from './CommonYesNo';

const options: Array<string> = ['', 'Yes', 'No'];

interface CommonYesNoContainerProps {
  label: string;
  name: string;
  value: boolean | null;
  setValue: Function;
  editable: boolean;
  disabled: boolean;
};

interface CommonYesNoContainerState {
  matchingPhotoIndex: number;
};

class CommonYesNoContainer extends Component<CommonYesNoContainerProps, CommonYesNoContainerState> {

  state: CommonYesNoContainerState = {
    matchingPhotoIndex: 0
  }

  componentDidUpdate(prevProps:CommonYesNoContainerProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({matchingPhotoIndex: this.setMatchingPhotoIndex(this.props.value)});
    }
  }

  setMatchingPhotoIndex = (matchingPhoto: boolean | null): number => {

    const matchingPhotoIndex: number = matchingPhoto === null ? 0 : matchingPhoto === true ? 1 : 2;

    return matchingPhotoIndex;
  }

  handleChange = (event: any): void => {
    const value: string = event.target.value;
    let matchingPhotoIndex: number = 0;
    let resultValue: boolean | null = null;

    if (value === 'Yes') {
      resultValue = true;
      matchingPhotoIndex = 1;
    } 

    if (value === 'No') {
      resultValue = false;
      matchingPhotoIndex = 2;
    }

    this.props.setValue(resultValue);
    this.setState({ matchingPhotoIndex });
  }

  render () {
    return (
      <CommonYesNo 
        label={ this.props.label }
        name={ this.props.name }
        options={ options } 
        index={ this.state.matchingPhotoIndex } 
        handleChange={ this.handleChange } 
        editable={ this.props.editable }
        disabled={ this.props.disabled }
      />
    );
  }
}
export default CommonYesNoContainer;